<div>
    <label class="resetIcon" data-toggle="tooltip" title="Refresh Filters" (click)=resetFilters()></label></div>
